import React from "react"

import Layout from "../../components/layout"
import SEO from "../../components/seo"
import SiteHeader from "../../components/site-header"
import SiteFooter from "../../components/site-footer"

import PostFooter from "./post-footer"
import PostHero from "./post-hero"
import PostContent from "./post-content"

const Post = ({ location, data }) => {
  const { blogPost: post, previous, next, site } = data
  return (
    <Layout location={location} title={site.siteMetadata.title}>
      <SEO
        title={post.title}
        description={post.excerpt}
        imageSource={
          post.socialImage
            ? post.socialImage?.childImageSharp?.fluid.src
            : post.image?.childImageSharp?.fluid.src
        }
        keywords={post.keywords}
        imageAlt={post.imageAlt}
      />
      <SiteHeader location={location}></SiteHeader>
      <main className="main">
        <PostHero post={post} />
        <PostContent post={post} />
        <PostFooter {...{ previous, next }} />
      </main>
      <SiteFooter></SiteFooter>
    </Layout>
  )
}

export default Post
